import { IRootReducer } from '../../types/reducerTypes'

export const selectCurrentSeason = ({ seasons }: IRootReducer) =>
  seasons.currentSeason ?? null

export const selectCurrentSeasonProgress = ({ seasons }: IRootReducer) =>
  seasons.currentSeasonProgress ?? null

export const selectPastSeasons = ({ seasons }: IRootReducer) =>
  seasons.pastSeasons ?? []

export const selectPastSeasonProgress = ({ seasons }: IRootReducer) =>
  seasons.pastSeasonsProgress

export const selectRecentlyCompletedQuests = ({ seasons }: IRootReducer) =>
  seasons.recentlyCompletedQuests ?? []

export const selectCurrentSeasonGraduatedMemecoins = ({
  seasons,
}: IRootReducer) => seasons.currentSeasonGraduatedMemecoins ?? []

export const selectClaimPrizeTxHash = ({ seasons }: IRootReducer) =>
  seasons.claimPrizeTxHash ?? null

export const selectPreviousSeasonFocusingOn = ({ seasons }: IRootReducer) =>
  seasons.previousSeasonFocusingOn ?? null
